export default __webpack_public_path__ + "static/media/taco-bell.09ca7e89.png";